import { ChatBotUIProductPriceSummary } from "../types";
import { getProductPriceFormatter } from "./getProductPriceFormatter";

export const getProductCoverPriceText = (
  priceSummary: ChatBotUIProductPriceSummary,
  currencyCode: string
): string => {
  const formatPrice = getProductPriceFormatter(currencyCode).format;

  if (priceSummary.type === "variable") {
    return "Variable";
  }

  if (priceSummary.type === "range") {
    return `${formatPrice(priceSummary.minAmount)} - ${formatPrice(
      priceSummary.maxAmount
    )}`;
  }

  return formatPrice(priceSummary.amount);
};
